import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { AlertComponent } from '../Components/alert/alert.component';
import { BackButtonComponent } from '../Components/back-button/back-button.component';
import { AlertDialogComponent } from '../Components/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from '../Components/confirmation-dialog/confirmation-dialog.component';
import { OdsCheckboxComponent } from '../Components/ods-checkbox/ods-checkbox.component';
import { OdsButtonComponent } from '../Components/ods-button/ods-button.component';
import { OdsInputComponent } from '../Components/ods-input/ods-input.component';
import { OdsModalComponent } from '../Components/ods-modal/ods-modal.component';
import { StatusBadgeComponent } from '../Components/status-badge/status-badge.component';
import { TableComponent } from '../Components/table/table.component';
import { UploadFilesDialogComponent } from '../Components/upload-files-dialog/upload-files-dialog.component';
import { RouterModule } from '@angular/router';

const MATERIAL_MODULES = [
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatTooltipModule,
];

const SHARED_DECLARATIONS = [
  AlertComponent,
  BackButtonComponent,
  OdsCheckboxComponent,
  OdsButtonComponent,
  OdsInputComponent,
  OdsModalComponent,
  StatusBadgeComponent,
  TableComponent,
  ConfirmationDialogComponent,
  AlertDialogComponent,
  UploadFilesDialogComponent,
  TableComponent,
];

@NgModule({
  declarations: SHARED_DECLARATIONS,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ...MATERIAL_MODULES,
    NgxMatSelectSearchModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...MATERIAL_MODULES,
    NgxMatSelectSearchModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ...SHARED_DECLARATIONS,
  ],
})
export class SharedModule {}
